module.exports = __webpack_public_path__ + "c2eabeaea2c88e61cb23ae6ce0e3d534.svg";